<template>
  <div class="containerResumoHistorical">
    <v-row class="d-flex justify-end mb-9 myButtonResumeHistorical" v-if="show == true">
      <v-col cols="12" md="auto">
        <BaseButton
          v-html="'VER HISTÓRICO'"
          color="secondary"
          outlined
          width="100%"
          @click="redirectToHistorical"
        />
      </v-col>
      <v-col cols="12" md="auto" class="mt-2 mt-md-0 md-3 ml-3">
        <BaseButton
          v-html="'RESUMO DA SOLICITAÇÃO'"
          class="secondary"
          width="100%"
          @click="redirectToResume"
        />
      </v-col>
    </v-row>
    <div>
      <HistoricalQuotationAgro
        v-if="
          currentQuotation != null && showHistoricalAgro && isVisible == true
        "
        @return="visible"
        :form="currentQuotation"
      />
      <ResumeProcessAgro
        v-if="
          currentQuotation != null && showResumeProcessAgro && isVisible == true
        "
        @return="visible"
        :form="currentQuotation"
      />
    </div>
  </div>
</template>

<script>
import ResumeProcessAgro from "../views/ResumeProcessAgro";
import HistoricalQuotationAgro from "../views/HistoricalQuotationAgro";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";

export default {
  name: "ViewResumeHistorical",
  data: () => ({
    showResumeProcessAgro: false,
    showHistoricalAgro: false,
    show: true,
    isVisible: true
  }),
  components: {
    ResumeProcessAgro,
    HistoricalQuotationAgro
  },
  mixins: [QuotationMixin],
  computed: {
    ...mapState("me", ["userIsEmployee", "userIsGuest"]),
    ...mapState("quotation", ["currentQuotation"]),
    getIsEmployeeUser() {
      return this.userIsEmployee;
    }
  },
  methods: {
    ...mapActions("quotation", ["requestCurrentQuotationAgro"]),
    fetchCurrentQuotation() {
      const id = this.$route.params?.id;
      if (id != null) {
        this.withLoading(this.requestCurrentQuotationAgro(id)).then(x => {
          if (x != null && this.currentQuotation != null) {
            return this.currentQuotation;
          }
        });
      }
    },
    redirectToHistorical() {
      this.fetchCurrentQuotation();
      this.showResumeProcessAgro = false;
      this.isVisible = true;
      this.show = false; //Esconde os botões ao habilitar a tela
      this.$emit("updateShowForm"); // Emite para o componente pai para desabilitar os outros componentes.
      this.showHistoricalAgro = true; // habilita a visualização do componente.
    },
    redirectToResume() {
      this.fetchCurrentQuotation();
      this.showHistoricalAgro = false;
      this.show = false;
      this.isVisible = true;
      this.$emit("updateShowForm");
      this.showResumeProcessAgro = true;
    },
    visible() {
      this.isVisible = false; //Quando damos back no componente que está aberto.
      this.show = true; // volta a aparecer os botões.
      this.$emit("return"); // emite para o pai avisando que fechamos o componente.
    }
  }
};
</script>
<style lang="sass">
.containerResumoHistorical
  max-width: 95% !important
  margin: 0 auto !important
.myButtonResumeHistorical
  margin-right: 135px !important
</style>
